module.exports = __webpack_public_path__ + "img/Porto Apartment - 1 of 85.3b779d94.jpeg";